import Component from "vue-class-component";
import Vue from "vue";

import { StateMachine } from "frontend-core";
import { IAgentService } from "@/services/IAgentService";
import { container } from "@/services/registerServiceProvider";
import { Agent } from "@/models/Agent";
import { ISearchProperty } from "@/models/SearchProperty";


@Component
export class SearchAgentsMixin extends Vue {
  public searchStr: string = "";
  public readonly stateMachine: StateMachine = new StateMachine("idle", {
    idle: ["loading", "error"],
    loading: ["idle", "error"],
    error: ["idle", "loading"]
  });
  public readonly agentService: IAgentService = container.resolve("IAgentService");
  public readonly agentArray: Agent[] = [];
  public searchProperties: ISearchProperty[] = [];
  public searchProperty: ISearchProperty = this.searchProperties[0];
  public notFound: boolean = false;

  get errorMessages(): string[] {
    return this.stateMachine.state === "error"
      ? ["Ничего не найдено"]
      : [];
  }

  async searchAgent(): Promise<void> {
    if (this.searchStr && this.stateMachine.state !== 'loading') {
      this.stateMachine.transition("loading");

      await this.agentService.search(this.searchStr, this.searchProperty.value)
        .then((agent) => {
          this.agentArray.splice(0, this.agentArray.length, ...agent);
        })
        .catch(() => {
          this.agentArray.splice(0);
        })
        .finally(() => {
          if (this.agentArray.length === 0) {
            this.stateMachine.transition("error");
          } else {
            this.stateMachine.transition("idle");
          }

          this.notFound = this.agentArray.length === 0;
        });
    }
  }

  clearErrors(): void {
    this.notFound = false;

    if (this.stateMachine.state === 'error') {
      this.stateMachine.transition("idle");
    }
  }
}